// extracted by mini-css-extract-plugin
module.exports = {"bounce":"page-module--bounce--3EoXV","pageInner":"page-module--pageInner--3vp1X"};